import './styles.css'
import Routes from './Routes'

export default Routes